module.exports = __webpack_public_path__ + "static/img/SHAUN-WATSON.621ebef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SHAUN-WATSON.jpg
// module id = o88p
// module chunks = 0